<!-- 默认布局 -->
<template>
  <div class="page-container">
    <PageHeader></PageHeader>
    <router-view></router-view>
    <PageFooter></PageFooter>
    <FloatWindow></FloatWindow>
  </div>
</template>

<script>
import PageHeader from "./components/PageHeader.vue";
import PageFooter from "./components/PageFooter.vue";
import FloatWindow from "./components/FloatWindow/index.vue";

export default {
  components: {
    PageHeader,
    PageFooter,
    FloatWindow
  },
  methods:{}
};
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
  max-width: @max-page-width;
  min-width: @content-width;
  margin: 0 auto;
  outline: 1px solid #eee;
  box-shadow: 0px 4px 4px 0px rgba(20, 86, 168, 0.06);
  // overflow: auto;
  position: relative;
}
</style>
